module.exports = __webpack_public_path__ + "img/service-desc-bg.97b68123.png";